import { render } from "./IconLogoGithub.vue?vue&type=template&id=23a15714&bindings={\"height\":\"props\",\"width\":\"props\"}"
import script from "./IconLogoGithub.vue?vue&type=script&lang=js"
export * from "./IconLogoGithub.vue?vue&type=script&lang=js"
script.render = render

export default script